import { Textarea } from "@windmill/react-ui";
import React from "react";

const TextAreaCom = ({
  register,
  name,
  label,
  placeholder,
  required,
  type,
  value,
  onChangeFunction,
  readOnly,
}) => {

  return (
    <>
      <Textarea
        className="focus:shadow-none border text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
        {...register(`${name}`, {
             required: required ? `${label} is required!` : false,
        })}
        type={type}
        placeholder={placeholder}
        name={name}
        value={value}
        readOnly={readOnly}
        rows="5"
        // onChange={(e) =>
        //   name === "terms_condition" ? null : onChangeFunction(e)
        // }
        onChange={(e) => {
          if (name !== "terms_condition" && onChangeFunction) {
            onChangeFunction(e);
          }
        }}
      />
    </>
  );
};

export default TextAreaCom;
